export default {
  'payment.stats.paidAmount': 'Paid amount',
  'payment.stats.paidCount': 'Successful payments',
  'payment.stats.attempts': 'Payment attempts',
  'payment.stats.orders': 'Orders',
  'payment.stats.successRate': 'Success rate',
  'payment.stats.aliasCount': 'Aliases',
  'payment.stats.paidCountHint': 'Successful payment rows in range',
  'payment.stats.paidCountHintDeduped': 'Paid orders in range (per alias, deduped)',
  'payment.stats.attemptsHint': 'All payment rows in range',
  'payment.stats.ordersHint': 'Orders in range (per alias, deduped)',
  'payment.stats.successHint': '{paid} succeeded / {attempts} attempts',
  'payment.stats.successHintDeduped': '{paid} paid / {orders} orders',
  'payment.chart.title': 'Top aliases by amount',
  'payment.chart.desc': 'Top {limit} by paid amount; remainder as Other',
  'payment.chart.descDeduped':
    'Deduped by order; top {limit} shown, remainder as Other',
  'payment.table.title': 'Reconciliation detail',
  'payment.table.desc':
    'By pay_config.alias: attempts, successes, rate & paid amount (updated_at)',
  'payment.table.descFull':
    'By pay_config.alias: attempts, successes, rate & paid amount (updated_at; includes retries)',
  'payment.table.descDeduped':
    'By pay_config.alias: orders, paid orders, rate & paid amount (deduped per order+alias+bucket; updated_at)',
  'payment.table.modeTotal': 'Total',
  'payment.table.modeDetail': 'By day',
  'payment.table.search': 'Search alias…',
  'payment.table.rowCount': '{count} rows',
  'payment.table.empty': 'No payment alias stats',
  'payment.table.bucketDay': 'Date',
  'payment.table.bucketHour': 'Hour',
  'payment.table.bucketMonth': 'Month',
  'payment.table.alias': 'Alias',
  'payment.table.attempts': 'Attempts',
  'payment.table.orders': 'Orders',
  'payment.table.success': 'Succeeded',
  'payment.table.successRate': 'Success rate',
  'payment.table.paidAmount': 'Paid amount',
  'payment.table.otherAliases': 'Other ({count} aliases)',
  'payment.chart.countLineDeduped': '{paid} paid / {orders} orders',
  'payment.filters.statMode': 'Stat mode',
  'payment.filters.statModeDeduped': 'Deduped by order',
  'payment.filters.statModeFull': 'All attempts',
  'payment.filters.groupBy': 'Bucket',
  'payment.filters.groupByDay': 'Day',
  'payment.filters.groupByHour': 'Hour',
  'payment.filters.groupByMonth': 'Month',
};
